import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import { useEmployeeSelfService } from '../../../contexts/EmployeeSelfServiceContext';

const tabs = [
  { path: '/erp/employee-self-service', icon: 'Home', label: 'Home' },
  { path: '/erp/employee-self-service/attendance-details', icon: 'Clock', label: 'Attendance' },
  { path: '/erp/employee-self-service/leave', icon: 'Calendar', label: 'Leave' },
  { path: '/erp/employee-self-service/payslip', icon: 'Wallet', label: 'Payslip' },
  { path: '/erp/employee-self-service/profile', icon: 'User', label: 'Profile' },
];

const MobileQuickBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { unreadCount } = useEmployeeSelfService();

  return (
    <nav className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-card border-t border-border safe-area-pb">
      <div className="flex justify-around items-center h-16">
        {tabs.map((tab) => {
          const active = location.pathname === tab.path || (tab.path !== '/erp/employee-self-service' && location.pathname.startsWith(tab.path));
          return (
            <button
              key={tab.path}
              type="button"
              onClick={() => navigate(tab.path)}
              className={`flex flex-col items-center justify-center flex-1 h-full text-xs gap-0.5 ${active ? 'text-primary' : 'text-muted-foreground'}`}
            >
              <span className="relative">
                <Icon name={tab.icon} size={20} />
                {tab.icon === 'Home' && unreadCount > 0 && (
                  <span className="absolute -top-1 -right-2 bg-red-500 text-white text-[10px] rounded-full min-w-[16px] h-4 px-1 flex items-center justify-center">
                    {unreadCount > 9 ? '9+' : unreadCount}
                  </span>
                )}
              </span>
              <span>{tab.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileQuickBar;
